import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Loader from '../../../../_common/Loader/Loader';
import classes from './tabs.module.scss';
import Pagination from '../../../../_common/Pagination/Pagination';
import accountHelpers from '../../../../../utils/accountHelpers';
import api from '../../../../../api/api';

const tableHeader = [
  {
    name: 'Physician name',
    path: 'name',
  },
  {
    name: 'Phone',
    path: 'phone',
  },
  {
    name: 'Email',
    path: 'email',
  },
  {
    name: 'Group',
    path: 'group',
  },
];

function GroupMembers() {
  const { physiciansList } = useSelector((store) => store.physicians);

  const [requestData, setRequestData] = useState({
    userId: accountHelpers.getUser().id,
    limit: 15,
    page: 1,
  });

  const [totalPage, setTotalPage] = useState(1);
  const [groupData, setGroupData] = useState([]);

  const [loading, setLoading] = useState(false);

  const { limit, page } = requestData;

  useEffect(() => {
    if (physiciansList[0].group) {
      (async () => {
        setLoading(true);
        const { data: { data: { response, _meta: { pageCount } } } } = await api.getPhysicians({
          ...requestData,
          group: physiciansList[0].group,
        });

        setTotalPage(pageCount);

        setGroupData(response);

        setLoading(false);
      })();
    }
  }, [physiciansList[0].group]);

  const onChangePageData = async (path, count) => {
    setLoading(true);

    const newRequestData = { ...requestData, [path]: count, group: physiciansList[0].group };

    if (path === 'limit') {
      newRequestData.page = 1;
    }

    const { data: { data: { response } } } = await api.getPhysicians(newRequestData);

    setGroupData(response);

    setRequestData(newRequestData);

    setLoading(false);
  };

  return (
    loading ? <Loader className={classes.loader} />
      : !groupData.length
        ? <div className={classes.notResult}>No Data Found</div>
        : (
          <>

            <div className={classes.table_wrapper}>

              {loading && <Loader />}

              <table>

                <thead>
                  <tr>
                    {tableHeader.map((h) => (
                      <th key={h.name}>{h.name}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {physiciansList.map((s) => (
                    <tr key={s.id} style={{ cursor: 'default' }}>
                      {tableHeader.map((h) => (
                        h.path === 'name'
                          ? <td key={h.name}>{`${s?.firstName} ${s?.lastName} `}</td>
                          : <td key={h.name}>{_.get(s, h.path) || '-'}</td>
                      ))}

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Pagination
              page={+page - 1}
              limit={limit}
              totalPage={+totalPage}
              onChange={onChangePageData}
            />

          </>
        )

  );
}

export default GroupMembers;
